// extracted by mini-css-extract-plugin
export default {"SocialButton":"SocialButton_SocialButton__D5LYb","SocialButton__img":"SocialButton_SocialButton__img__svVmE"};